module.exports = __webpack_public_path__ + "static/img/progress-active.51acf26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress-active.png
// module id = jXhC
// module chunks = 1